import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Ticker } from './components/Ticker';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Audit } from './components/Audit';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { SplashScreen } from './components/SplashScreen';
import { LavaLampBackground } from './components/LavaLampBackground';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  return <>
      <AnimatePresence mode="wait" data-id="element-0">
        {showSplash ? <SplashScreen key="splash" onComplete={() => setShowSplash(false)} data-id="element-1" /> : <motion.div key="main" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="min-h-screen w-full" data-id="element-2">
            <LavaLampBackground data-id="element-3" />
            <Navbar data-id="element-4" />
            <main data-id="element-5">
              <Hero data-id="element-6" />
              <Ticker data-id="element-7" />
              <Stats data-id="element-8" />
              <Services data-id="element-9" />
              <Process data-id="element-10" />
              <Audit data-id="element-11" />
              <Testimonials data-id="element-12" />
              <CTA data-id="element-13" />
            </main>
            <Footer data-id="element-14" />
          </motion.div>}
      </AnimatePresence>
    </>;
}